module.exports = __webpack_public_path__ + "static/media/auth-banner.84133f09.png";